import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from '@/pages/HomePage';
import ConfiguratorPage from '@/pages/ConfiguratorPage';
import ProductsPage from '@/pages/ProductsPage';
import SelectionGuidePage from '@/pages/SelectionGuidePage';
import ApplicationsPage from '@/pages/ApplicationsPage';
import CertificationsPage from '@/pages/CertificationsPage';
import AdminDashboard from '@/pages/AdminDashboard';
import ResetPasswordPage from '@/pages/ResetPasswordPage';
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage';
import TermsOfUsePage from '@/pages/TermsOfUsePage';
import { Toaster } from '@/components/ui/sonner';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/configure" element={<ConfiguratorPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/selection-guide" element={<SelectionGuidePage />} />
          <Route path="/applications" element={<ApplicationsPage />} />
          <Route path="/certifications" element={<CertificationsPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/reset-password" element={<ResetPasswordPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-use" element={<TermsOfUsePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;